module.exports = __webpack_public_path__ + "static/media/slider_2_en_sm.9ab8284a.svg";